/**
 * The release center feed request, shared by MessageReceiptList and the tab
 * prefetch (renderer/utils/prefetchPage.ts), which warms the same store bank.
 */
export const RELEASE_FEED_KEY = 'fetchMessages';
export const RELEASE_FEED_INPUT = '/api/v1/messageReceipt/me';

export function releaseFeedBaseQuery(role: string | undefined) {
  return role === 'admin' || role === 'staff' ? { withMessageMeta: true } : undefined;
}

/** The query `useNextInfiniteRequest` sends for the feed's first page. */
export function releaseFeedInitialQuery(role: string | undefined) {
  return {
    ...releaseFeedBaseQuery(role),
    order: { by: 'id', dir: 'DESC' },
    page: { limit: 50 },
  };
}
